import { IPayloadDelete } from '~/utils/interface/customer';
import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import { ICRMStatus, IParamsGetCRMStatus, IResponseGetCRMStatus, IUpdatePosition } from '~/utils/interface/crm-status';

const url = `api/admin/crm-statuses`;

const crmStatusApi = {
  create(data: ICRMStatus) {
    return axiosClient.post<IApiBaseResponse<ICRMStatus>>(url, data);
  },
  getList(params: IParamsGetCRMStatus) {
    return axiosClient.get<IApiBaseResponse<IResponseGetCRMStatus>>(`api/admin/crm-statuses`, { params });
  },
  getDetail(id: string) {
    return axiosClient.get<IApiBaseResponse<ICRMStatus>>(`api/admin/crm-statuses/${id}`);
  },
  delete(data: IPayloadDelete) {
    return axiosClient.delete<IApiBaseResponse<null>>(url, { data });
  },
  update(id: string | undefined, data: ICRMStatus) {
    return axiosClient.put<IApiBaseResponse<ICRMStatus>>(`api/admin/crm-statuses/${id}`, data);
  },
  updatePosition(id: string | undefined, data: IUpdatePosition) {
    return axiosClient.put<IApiBaseResponse<ICRMStatus>>(`api/admin/crm-statuses/position/${id}`, data);
  },
};

export default crmStatusApi;
